// import { getHours, getMinutes } from "date-fns";
import moment from 'moment';

const MAX_MILISECONDS = 1000;
const MAX_SECONDS = 60;
const MAX_MINUTES = 60;
const MAX_HOURS = 24;

export const ONE_DAY = (MAX_HOURS * MAX_MINUTES * MAX_SECONDS * MAX_MILISECONDS);
export const ONE_HOUR = (MAX_MINUTES * MAX_SECONDS * MAX_MILISECONDS);
export const ONE_MINUTE = (MAX_SECONDS * MAX_MILISECONDS);

export const getDate = (date, format) => date
    && (!format
      ? new Date(date).toLocaleDateString('pt-BR')
      : moment(date).format(format)
    );

export const getDifferenceTime = (date) => {
  return moment(date).fromNow();
};

export const getHourMinutes = date => (date && Object.entries(date).length > 0
  ? `${new Date(date).getHours().toString().padStart(2, '0')}:${new Date(date).getMinutes().toString().padStart(2, '0')}`
  : ''
);

export const setHourMinutes = (date, time) => {
  const tempDate = new Date(date);
  tempDate.setHours(
    time.substr(0, time.indexOf(':')),
    time.substr(time.indexOf(':') + 1, 2),
  );
  return tempDate;
};
